<template>
	<div class="container">
		<Header />
		<MainClinic />
		<Footer />
	</div>
</template>

<script>
import Header from '@/layout/Header.vue';
import Footer from '@/layout/Footer.vue';
import MainClinic from '@/layout/MainClinic.vue';

export default {
	data() {
		return {

		}
	},
	components: {
		Header,
		Footer,
		MainClinic,
	},
	created() {

	},
	methods: {

	}
}
</script>
<style>

</style>
<style lang="less" scoped>
.container {
	width: 100%;
	max-width: 100% !important;
	min-height: calc(100vh - 144px);
}
</style>
